<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row">
        <label :for="safeId('title')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Athlete</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId" :dataset-id="datasetId"></record-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('attempt1')" class="col-sm-4 col-form-label">Attempt 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('attempt1')" v-model.lazy="attempt1">
          <div class="mt-1 btn-group btn-group-justified">
            <button class="btn btn-success" @click="take(1)">TAKE</button>
            <button class="btn btn-secondary" @click="dnf(1)">DNF</button>
            <button class="btn btn-warning" @click="clr(1)">CLR</button>
          </div>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('attempt2')" class="col-sm-4 col-form-label">Attempt 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('attempt2')" v-model.lazy="attempt2">
          <div class="mt-1 btn-group btn-group-justified">
            <button class="btn btn-success" @click="take(2)">TAKE</button>
            <button class="btn btn-secondary" @click="dnf(2)">DNF</button>
            <button class="btn btn-warning" @click="clr(2)">CLR</button>
          </div>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('attempt3')" class="col-sm-4 col-form-label">Attempt 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('attempt3')" v-model.lazy="attempt3">
          <div class="mt-1 btn-group btn-group-justified">
            <button class="btn btn-success" @click="take(3)">TAKE</button>
            <button class="btn btn-secondary" @click="dnf(3)">DNF</button>
            <button class="btn btn-warning" @click="clr(3)">CLR</button>
          </div>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('best')" class="col-sm-4 col-form-label">Best</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('best')" v-model.lazy="best">
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('clockId')" class="col-sm-4 col-form-label">Clock</label>
        <div class="col-sm-8">
          <template-select :id="safeId('clockId')" v-model="clockId"></template-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row" v-for="(v, k) in columnDefinitions" :key="k">
        <label :for="safeId(k)" class="col-sm-4 col-form-label">{{ v }}</label>
        <div class="col-sm-8">
          <column-select :id="safeId(k)" :value="columnMap[k]" @input="val => {
            columnMap[k] = val
            columnMap = columnMap
          }" :dataset-id="datasetId"></column-select>
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
        <div class="form-group form-row">
          <label :for="safeId('maxRecords')" class="col-sm-4 col-form-label">Max records</label>
          <div class="col-sm-8">
            <input type="number" class="form-control" :id="safeId('maxRecords')" v-model.lazy="maxRecords">
          </div>
        </div>
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
  import * as lib from '../../lib'
  import { templateMixin } from '@/mixins'
  import { rank, mapOverlayData, mapTemplateData, mapTemplateOptions } from '@/utils'
  import * as action from '@/store/action-types'
  import * as mutation from '@/store/mutation-types'
  import RecordSelect from '../ui/record-select'

  function formatTimeDiff (ms) {
    let time = ms < 0 ? new Date(-ms) : new Date(ms)
    let result = ''
    if (time.getMinutes() > 0) {
      result = time.getMinutes() +
        ':' + ('0' + time.getSeconds()).slice(-2)
    } else {
      result = time.getSeconds() +
        '.' + ('00' + time.getMilliseconds()).slice(-3, -1)
    }
    result = (ms < 0 ? '-' : '+') + result
    return result
  }

  export default {
    components: {RecordSelect},
    name: 'uiaa-speed-intermediate-standings',
    mixins: [templateMixin],
    data () {
      return {
        columnDefinitions: {
          'bibNumber': 'Bib number',
          'lastName': 'Name',
          'country': 'Country',
          'attempt1': 'Attempt 1',
          'attempt2': 'Attempt 2',
          'attempt3': 'Attempt 3',
          'best': 'Best'
        }
      }
    },
    computed: {
      ...mapOverlayData(['title']),
      ...mapOverlayData({'records': {default: []}}),
      ...mapTemplateData(['clockId', 'datasetId', 'recordId']),
      ...mapTemplateData({columnMap: {default: {}}}),
      ...mapTemplateOptions({'maxRecords': {type: Number, default: 12}}),
      dataset () {
        if (!this.datasetId) return null
        return this.$store.getters.dataset(this.datasetId)
      },
      records () {
        const dataset = this.dataset
        if (!dataset) return []
        return [].concat(dataset.records.map(record => {
          const result = this.mapRecord(record, this.columnMap)
          // Map recordId to find current record after sorting and ranking
          result.recordId = record.recordId
          // Map rawTime for further calculations
          result.rawTime = lib.timeStrToInt(result.best) || Number.MAX_SAFE_INTEGER
          result.timeDiff = result.best
          result.active = record.recordId === this.recordId
          return result
        }))
      },
      timeRecords () {
        let records = this.records
          .filter(each => each.attempt1)
        records.sort((a, b) => {
          return a.rawTime - b.rawTime
        })
        // Calculate time diff to leader
        const leader = records.find(r => r.recordId !== this.recordId)
        if (leader) {
          const baseRawTime = leader.rawTime
          leader.timeDiff = leader.best
          records.forEach(each => {
            if (each.recordId === leader.recordId) return each
            if (each.rawTime === Number.MAX_SAFE_INTEGER) {
              each.timeDiff = 'DNF'
            } else {
              each.timeDiff = formatTimeDiff(each.rawTime - baseRawTime)
            }
          })
        }
        // Rank records according to score
        records.forEach(rank('rank', 'rawTime'))
        return this.sliceRecords(records, this.recordId)
      },
      record () {
        if (!this.dataset || !this.recordId) return null
        return this.dataset.records.find(r => r.recordId === this.recordId)
      },
      attempt1: {
        get () {
          if (!this.record) return null
          return this.record[this.columnMap['attempt1']]
        },
        set (val) {
          this.updateCell(this.columnMap['attempt1'], val)
          this.setBest(val, this.attempt2, this.attempt3)
        }
      },
      attempt2: {
        get () {
          if (!this.record) return null
          return this.record[this.columnMap['attempt2']]
        },
        set (val) {
          this.updateCell(this.columnMap['attempt2'], val)
          this.setBest(this.attempt1, val, this.attempt3)
        }
      },
      attempt3: {
        get () {
          if (!this.record) return null
          return this.record[this.columnMap['attempt3']]
        },
        set (val) {
          this.updateCell(this.columnMap['attempt3'], val)
          this.setBest(this.attempt1, this.attempt2, val)
        }
      },
      best: {
        get () {
          if (!this.record) return null
          return this.record[this.columnMap['best']]
        },
        set (val) {
          this.updateCell(this.columnMap['best'], val)
        }
      }
    },
    watch: {
      timeRecords: function (val) {
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data: {records: val}
        })
      }
    },
    methods: {
      formatTime (ms) {
        console.log('formatTime', ms)
        if ((ms <= 0) || (ms === Number.MAX_SAFE_INTEGER)) return 'DNF'
        const date = new Date(ms)
        if (date.getMinutes() > 0) {
          return date.getMinutes() +
            ':' + ('0' + date.getSeconds()).slice(-2) +
            '.' + ('00' + date.getMilliseconds()).slice(-3, -1)
        } else {
          return date.getSeconds() +
            '.' + ('00' + date.getMilliseconds()).slice(-3, -1)
        }
      },
      take (attempt) {
        this['attempt' + attempt] = this.formatTime(this.getElapsedMs())
      },
      dnf (attempt) {
        this['attempt' + attempt] = '-'
      },
      clr (attempt) {
        this['attempt' + attempt] = ''
      },
      setBest (a1, a2, a3) {
        a1 = lib.timeStrToInt(a1) || Number.MAX_SAFE_INTEGER
        a2 = lib.timeStrToInt(a2) || Number.MAX_SAFE_INTEGER
        a3 = lib.timeStrToInt(a3) || Number.MAX_SAFE_INTEGER
        const best = Math.min(a1, Math.min(a2, a3))
        this.best = this.formatTime(best)
      },
      getElapsedMs () {
        const data = this.$store.getters.overlayData(this.clockId)
        if (!data || data === {}) return console.warn('[intermediate-standings] clock overlay data is empty')
        const stopwatch = new lib.Stopwatch(data)
        return stopwatch.elapsedMs
      },
      mapRecord (record, columnMap) {
        return Object.keys(columnMap).reduce((result, key) => {
          result[key] = record[columnMap[key]]
          return result
        }, {})
      },
      updateCell (column, value) {
        this.$store.commit(mutation.DATASET_UPDATE_VALUE, {
          datasetId: this.datasetId,
          recordId: this.recordId,
          column,
          value,
          emit: true
        })
      },
      sliceRecords (records, recordId) {
        const maxRecords = this.maxRecords
        // Save index of current athlete
        let idx = records.findIndex(each => each.recordId === recordId)

        // If current athlete is in top (maxRecords), return top (maxRecords)
        if (idx < maxRecords) {
          return records.slice(0, maxRecords)
        }

        // Otherwise return top (maxRecords - 1) with current athlete at the end
        const record = records[idx]
        records = records.slice(0, maxRecords - 1)
        records.push(record)
        return records
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/uiaa-speed-intermediate-standings.vue